import { useNavigate } from 'react-router-dom';
import { SplashScreen } from '../components/common/SplashScreen';

export default function SplashPage() {
  const navigate = useNavigate();
  return (
    <SplashScreen onComplete={() => navigate('/dashboard', { replace: true })} />
  );
}
